<template>
  <div class="flex overflow-hidden">
    <div class="w-full lg:flex">
      <div class="grid grid-cols-1 w-full gap-4">
        <h2 class="ml-2 text-base leading-6 font-medium text-gray-600">Ordenes en Proceso</h2>
        <data-table :rows="runningorders" :headers="runningordersheader" class="mb-2"/>
        <h2 class="ml-2 text-base leading-6 font-medium text-gray-600">Ordenes Pendientes</h2>
        <data-table :rows="pendingorders" :headers="pendingordersheader" class="mb-2"/>
        <h2 class="ml-2 text-base leading-6 font-medium text-gray-600">Ordenes Completadas</h2>
        <data-table :rows="completedorders" :headers="completedordersheader" class="mb-2"/>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from '@/components/DataTable/DataTable'
export default {
  name: 'FlowBacklog',
  components: { DataTable },
  data() {
    return {
      runningorders: [],
      runningordersheader: [],
      pendinggorders: [],
      pendinggordersheader: [],
      completedorders: [],
      completedordersheader: []
    }
  },

  created() {
    this.fetchOrders()
  },

  methods: {
    async fetchOrders() {
      let response = await this.$http.get(`flow/custom/orders?state=running`)
      this.runningorders = response.data.orders
      let headers = await this.$http.get(`tables?table=flow_runningorders`)
      this.runningordersheader = headers.data

      response = await this.$http.get(`flow/custom/orders?state=pending`)
      this.pendingorders = response.data.orders
      headers = await this.$http.get(`tables?table=flow_pendingorders`)
      this.pendingordersheader = headers.data

      response = await this.$http.get(`flow/custom/orders?state=completed`)
      this.completedorders = response.data.orders
      headers = await this.$http.get(`tables?table=flow_completedorders`)
      this.completedordersheader = headers.data
    }
  }
}
</script>
